module.exports = __webpack_public_path__ + "static/media/bookbasket_won.953bd297.png";